import axios from "axios";
import settings from "../settings";
import router from "../router";
let new_client_data = {
    is_new: true,
    name: null,
    chain_name: null,
    shop_name: null,
    shop_type: null,
    business_type: null,
    company_id: null,
    store_id: null,
    country: null,
    shop_address: null,
    shop_place: null,
    shop_parish: null,
    shop_county: null,
    shop_index: null,
    shop_country: null,
    shop_country_code: null,
    latitude: null,
    longitude: null,
    comment: null,
    codes: []
};

const new_code_data = {
    code: null,
    partner: "odoo"
};
const listSettingsColumns = [
    {
        value: "name",
        text: "Name",
        align: "left",
        isSelected: true
    },
    {
        value: "chain_name",
        text: "Chain name",
        align: "left",
        isSelected: true
    },
    {
        value: "shop_name",
        text: "Shop name",
        align: "left",
        isSelected: true
    },
    {
        value: "country",
        text: "Country",
        align: "left",
        isSelected: true
    },
    {
        value: "flag",
        text: "Flag",
        align: "left",
        isSelected: true
    },
    {
        value: "address",
        text: "Address",
        align: "left",
        isSelected: true
    },
    {
        value: "comment",
        text: "Comment",
        align: "left",
        isSelected: false
    }
];
let initialState = {
    loadingClientList: false,
    loadingClientData: false,
    requestSuccess: false,
    requestError: false,
    drawerOpen: false,
    clients: [],
    activeClient: {},
    errorMessage: "",
    searchClientString: "",
    tableOptions: null,
    exportInvoiceDialog: false,
    listSettingsModal: false,
    listSettingsColumns: listSettingsColumns,
    clientTableHeaders: [],
    imageFileDialog: false,
    totalClientCount: 0
};
export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async getClientsList({ commit, state }, { options = null, search = null }) {
            commit("setRequestError", false);
            commit("setRequestSuccess", false);
            commit("setClientsListLoading", true);
            try {
                let params = {
                    search: search,
                    page: options && options.page ? options.page : null,
                    itemsPerPage: options && options.itemsPerPage ? options.itemsPerPage : null,
                    sortBy: options && options.sortBy[0] ? options.sortBy[0] : null,
                    sortDesc: options && options.sortDesc ? options.sortDesc[0] : null
                };
                let response = await axios.get(settings.api_url + "/clients/", {
                    params
                });
                let data = response.data;
                if (data.success === 1) {
                    commit("addClients", data.clients);
                }
                if (data.user_client_search_settings) {
                    commit("setMountedTableHeaders", data.user_client_search_settings);
                } else {
                    commit("setClientsTableHeaders");
                }
                if (data.total_clients_count) {
                    commit("setTotalClientCount", data.total_clients_count);
                }
                commit("setClientsListLoading", false);
            } catch (e) {
                console.log(e);
                commit("setClientsListLoading", false);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
        },
        async callGetClientsList({ dispatch, state }) {
            dispatch("getClientsList", {
                options: state.tableOptions,
                search: state.searchClientString
            });
        },
        async getClientData({ commit }, clientId) {
            commit("setClientDataLoading", true);
            commit("setRequestError", false);
            commit("setRequestSuccess", false);
            try {
                let response = await axios.get(settings.api_url + "/client/" + clientId);
                if (response && response.data && response.data.success === 1) {
                    let data = response.data;
                    commit("setActiveClient", data.client_data);
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }
                commit("setClientDataLoading", false);
            } catch (e) {
                console.log(e);
                commit("setClientDataLoading", false);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
        },
        async submitClientUpdate({ commit, dispatch, state }, payload) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);

            commit("setErrorMessage", "");
            try {
                let response = await axios.post(settings.api_url + "/client/", payload);
                if (response && response.data.success === 1) {
                    const clientId = response.data.client_id;
                    // Update activeClient with the returned ID (important for new clients)
                    if (clientId && state.activeClient) {
                        commit("updateActiveClientProperty", { prop: "id", value: clientId });
                    }
                    dispatch("callGetClientsList");
                    commit("setRequestSuccess", true);
                } else if (response.data.success === 0) {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
        },
        async deleteClient({ commit, dispatch }, { client_id }) {
            commit("setRequestSuccess", false);
            commit("setErrorMessage", "");
            commit("setClientsListLoading", true);
            try {
                let response = await axios.delete(settings.api_url + "/client/", { params: { client_id } });
                if (response && response.data.success === 1) {
                    dispatch("callGetClientsList");
                    commit("setRequestSuccess", true);
                } else if (response.data.success === 0) {
                    commit("setRequestError", true);
                    commit("setErrorMessage", "Failed");
                }
                commit("setClientsListLoading", false);
                router.push("/clients");
            } catch (e) {
                console.log(e);
                commit("setClientsListLoading", false);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
        },
        async mergeClient({ commit, dispatch }, { child_id, parent_id }) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            commit("setErrorMessage", "");
            commit("setClientsListLoading", true);
            try {
                let response = await axios.post(settings.api_url + "/clients/merge", {
                    child_id,
                    parent_id
                });
                if (response && response.data.success === 1) {
                    dispatch("callGetClientsList");
                    commit("setRequestSuccess", true);
                    router.push("/clients");
                    return { success: true, data: response.data.data };
                } else {
                    commit("setRequestError", true);
                    commit("setErrorMessage", response.data.error_msg || "Failed");
                    return { success: false, error: response.data.error_msg };
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
                return { success: false, error: "Request failed" };
            } finally {
                commit("setClientsListLoading", false);
            }
        },
        async importExcel({ commit, dispatch, state }, e) {
            console.log(e);
            commit("setClientsListLoading", true);

            let formData = new FormData();
            formData.append("file", e);
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                let response = await axios.post(settings.api_url + "/clients-excel/", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });
                if (response.status === 200) {
                    if (response.data.success === 1) {
                        commit("setRequestSuccess", true);
                    } else {
                        commit("setRequestError", true);
                        commit("setErrorMessage", response.data.error_msg);
                    }
                }
            } catch (e) {
                console.log(e);
            }
            await commit("setClientsListLoading", false);
            await dispatch("getClientsList", {
                options: state.tableOptions,
                search: state.searchClientString
            });
        }
    },
    mutations: {
        setTableOptions(state, options) {
            state.tableOptions = options;
            this.dispatch("ClientStore/callGetClientsList");
        },
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setRequestError(state, bool) {
            state.requestError = bool;
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        addClients(state, clients) {
            state.clients = clients;
        },
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        setClientsListLoading(state, value) {
            state.loadingClientList = value;
        },
        setClientDataLoading(state, value) {
            state.loadingClientData = value;
        },
        setActiveClient(state, client) {
            state.activeClient = client;
        },
        updateActiveClientProperty(state, { prop, value }) {
            state.activeClient = {
                ...state.activeClient,
                [prop]: value
            };
        },
        addNewClient(state) {
            state.activeClient = new_client_data;
        },
        addNewClientCode(state) {
            state.activeClient.codes.push({ ...new_code_data });
        },
        updateActiveClientCodeProperty(state, { prop, value, index }) {
            state.activeClient.codes[index] = {
                ...state.activeClient.codes[index],
                [prop]: value
            };
        },
        deleteClientCode(state, index) {
            state.activeClient.codes.splice(index, 1);
        },
        updateClientSearch(state, payload) {
            state.searchClientString = payload.term;
            this.dispatch("ClientStore/callGetClientsList");
        },
        resetClientSearch(state) {
            state.searchClientString = "";
        },
        setClientsTableHeaders(state) {
            state.clientTableHeaders = [];
            state.listSettingsColumns.map(x => {
                if (x.isSelected) {
                    x.align = "left";
                    state.clientTableHeaders.push(x);
                }
            });
            let length = state.clientTableHeaders.length;
            if (length > 2) {
                state.clientTableHeaders[length - 1].align = "center";
                state.clientTableHeaders[length - 2].align = "end";
            }
        },
        setMountedTableHeaders(state, value) {
            state.clientTableHeaders = value;
            let selected_array = state.clientTableHeaders.map(x => x.value);
            state.listSettingsColumns.forEach(x => {
                x.isSelected = selected_array.includes(x.value);
            });
        },
        toggleListSettingsColumn(state, item) {
            let column = state.listSettingsColumns.find(c => c.value === item.value);
            column.isSelected = !column.isSelected;
        },
        toggleListSettingsModal(state) {
            state.listSettingsModal = !state.listSettingsModal;
        },
        setImageFileDialog(state, bool) {
            state.imageFileDialog = bool;
        },
        setTotalClientCount(state, count) {
            state.totalClientCount = count;
        }
    },
    getters: {
        clientCount: state => {
            return state.clients.length;
        }
    }
};
